<script>
  import Html from '$lib/Html.svelte'

  export let hidden = false
  export let large = false

  /** @type {string?} */
  export let title = null
</script>

<div class="page-heading">
  <div class="content">
    {#if $$slots.tagline}
      <div class="tagline">
        <Html>
          <slot name="tagline" />
        </Html>
      </div>
    {/if}

    {#if title}
      <h1 class="title" class:large class:u-hidden={hidden}>{title}</h1>
    {/if}

    <div class="promotion">
      <slot name="promotion" />
    </div>

    {#if $$slots.body}
      <div class="body">
        <Html size="large">
          <slot name="body" />
        </Html>
      </div>
    {/if}

    {#if $$slots.content}
      <div class="children"><slot name="content" /></div>
    {/if}
  </div>
</div>

<style>
  .page-heading {
    --current-max-width: 25em;

    color: var(--current-color, rgb(var(--rgb-text)));
    margin-bottom: -1.75rem;
  }

  .tagline {
    --current-font-size: 0.875rem;
  }

  @media (width > 600px) {
    .tagline {
      --current-font-size: 1rem;
    }
  }

  @media (width > 600px) {
    .tagline {
      --current-font-size: 1.25rem;
    }
  }

  .tagline :global(p:last-child) {
    margin-bottom: 1.15rem !important;
  }

  .title {
    font-family: var(--heading-font-family);
    display: block;
    width: 100%;
    margin-left: -0.03em;
    font-size: 2.25rem;
    line-height: 1.05;
    font-weight: bold;
    letter-spacing: -0.01em;
    text-wrap: balance;
    max-width: 9.6em;
    word-spacing: -0.05em;
    letter-spacing: -0.02em;
  }

  .title.large {
    font-size: 3.5rem;
    line-height: 0.95;
  }

  .promotion {
    font-family: var(--heading-font-family);
    word-spacing: -0.05em;
    letter-spacing: -0.025em;
    font-size: 2.25rem;
    line-height: 1.05;
    max-width: 13em;
    text-wrap: pretty;
    font-weight: normal;
  }

  .promotion :global(p) {
    margin: 0 0 0.5em 0;
  }

  .promotion :global(a) {
    color: rgb(var(--rgb-link));
    text-decoration: underline;
    text-decoration-thickness: 2px;
    text-underline-offset: 0.1em;
    text-decoration-color: rgba(var(--rgb-link), 0.25);
    font-weight: 400;
    word-break: break-word;
    hyphens: auto;
    cursor: pointer;
    transition:
      var(--color-transition),
      text-decoration-color 100ms;
  }

  .promotion :global(a:hover) {
    text-decoration-color: rgba(var(--rgb-link), 1);
  }

  .promotion :global(a:active) {
    opacity: 0.7;
    transition: var(--color-active-transition);
  }

  .promotion :global(strong) {
    font-weight: 600;
  }

  @media (min-width: 900px) {
    .promotion {
      font-size: 4rem;
      line-height: 0.95;
    }

    .title.large {
      font-size: 5rem;
      line-height: 0.9;
    }
  }

  @media (min-width: 600px) {
    .title {
      font-size: 3rem;
      line-height: 1;
    }
  }

  @media (min-width: 1000px) {
    .title {
      font-size: 4rem;
      line-height: 1;
    }

    .title.large {
      font-size: 6.5rem;
      line-height: 0.9;
    }
  }

  @media (min-width: 1200px) {
    .title {
      font-size: 5rem;
      line-height: 0.9;
    }
  }

  .body {
    --current-font-size: 1.125rem;
    --current-line-height: 1.35;

    font-size: var(--current-font-size);
    margin-top: 0.75rem;
    max-width: 100%;
    text-wrap: pretty;
  }

  @media (min-width: 1000px) {
    .body {
      --current-font-size: 1.5rem;
      margin-top: 1rem;
    }
  }

  .children {
    width: 100%;
    margin-top: 1.75rem;
  }
</style>
